import { useSiteContext } from '~/context/SiteContext';

export default function useShopInfo() {
  const siteContext = useSiteContext();

  return siteContext?.globals?.shopInfo;
}
